import { BlockTitle } from "@blocks/Blocks";

/**
 * Component to render EE awards page
 */
const EEAwardsPage = (): React.ReactElement => {
  return (
    <div
      className="mb-6 font-public-sans"
      data-testid="ee-awards-page-component"
    >
      <BlockTitle
        text="Awards"
        rootClassName="text-4xl md:text-6xl lg:text-8xl font-medium mb-2"
      />

      <div className="flex flex-col leading-[1.4] md:flex-row">
        <div className="mx-3 mt-4 bg-gray-150 p-4 md:w-1/2">
          <p className="mb-1 font-bold">Emerging Enterprise Award</p>

          <p>
            Recognises emerging enterprises that demonstrate an enterprising
            mindset. These are businesses that drive consistent, significant and
            sustainable growth, resulting in excellent business performance; and
            display the ability to scale and expand overseas.
          </p>

          <p className="mb-2 leading-5">
            Winner(s) (or their newly-established subsidiary, partnership or
            sole proprietorship, where applicable) will each receive from:
          </p>

          <ul className="mb-4 list-outside list-disc pl-8">
            <li>
              OCBC Bank (or any of its subsidiaries in Malaysia, Indonesia
              and/or Hong Kong (collectively, &quot;OCBC Subsidiaries&quot; and
              each an &quot;OCBC Subsidiary&quot;) – a 2 year, interest-free
              term loan of up to SGD 200,000 (or MYR 600,000, or HKD 1,000,000,
              or IDR 2,000,000,000, as set out in the terms and conditions);
            </li>

            <li>
              The Business Times - Media publicity in print, digital, social
              media for Singapore and the region; and
            </li>

            <li>
              {" "}
              RSM - &quot;Consulting Package for Growing Businesses&quot; worth
              SGD$15,000.
            </li>
          </ul>

          <p className="mb-1 font-bold">Most Promising Startup Award</p>

          <p>
            Recognises emerging enterprises with a strong startup spirit. These
            are startups that have developed a unique and commercially viable
            idea, which has the potential to be sustained in the long run.
          </p>

          <p className="mb-2 leading-5">Winner(s) will receive from:</p>

          <ul className="list-outside list-disc pl-8">
            <li>
              The Business Times - Media publicity in print, digital, social
              media for Singapore and the region.
            </li>
          </ul>
        </div>

        <div className="mx-3 mt-4 bg-gray-150 p-4 md:w-1/2">
          <p className="mb-1 font-bold">
            Emerging Enterprise Sustainability Award
          </p>

          <p>
            Recognises emerging enterprises that are capitalising on growth
            opportunities in the green economy, embedding sustainability in
            their businesses and leveraging technology and new solutions to
            drive the change and transition to low-carbon businesses and
            industries.
          </p>

          <p className="mb-2 leading-5">
            Winner(s) (or their newly-established subsidiary, partnership or
            sole proprietorship, where applicable) will each receive from:
          </p>

          <ul className="mb-4 list-outside list-disc pl-8">
            <li>
              OCBC Bank (or an OCBC Subsidiary) – a 2 year, interest-free term
              loan of up to SGD 200,000 (or MYR 600,000, or HKD 1,000,000, or
              IDR 2,000,000,000, as set out in the terms and conditions);
            </li>

            <li>
              The Business Times - Media publicity in print, digital, social
              media for Singapore and the region; and
            </li>

            <li>
              RSM - &quot;Consulting Package for Growing Businesses&quot; worth
              SGD$15,000.
            </li>
          </ul>

          <p className="mb-1 font-bold">
            Most Promising Sustainability Startup Award
          </p>

          <p>
            Recognises emerging sustainability enterprises with a strong startup
            spirit. These are startups that have developed a unique and
            commercially viable idea, which has the potential to be sustained in
            the long run.
          </p>

          <p className="mb-2 leading-5">Winner(s) will receive from:</p>

          <ul className="list-outside list-disc pl-8">
            <li>
              The Business Times - Media publicity in print, digital, social
              media for Singapore and the region.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default EEAwardsPage;
